import { Tooltip } from 'antd';
import React, { FC } from 'react';

interface Props {
    data: dataItem[];
    labelStyle?: React.CSSProperties;
    style?: React.CSSProperties;
    onClick?: Function;
    selected?: dataItem[];
    className?: string;
    itemClassName?: string;
    showTooltip?: boolean;
}
type dataItem = {
    label: string;
    color: string;
    key?: string | number;
    style?: React.CSSProperties;
    fullLabel?: string;
};
const Legend: FC<Props> = ({
    data = [],
    style = {},
    labelStyle = {},
    onClick,
    selected,
    className = '',
    itemClassName = '',
    showTooltip = false,
}) => {
    const handleOnClick = (item: dataItem) => {
        if (onClick) {
            onClick(item);
        }
    };
    return (
        <div
            style={style}
            className="flex justify-start gap-6 items-center overflow-x-auto whitespace-nowrap px-5 py-0"
        >
            {data.map((item) => {
                const { style = {} } = item;
                let additionalClassName = '';
                if (selected && Array.isArray(selected) && onClick) {
                    if (selected.find((legend) => legend?.label === item?.label)) additionalClassName = 'opacity-50';
                }
                return (
                    <div
                        onClick={() => handleOnClick(item)}
                        key={item.label}
                        className={`items-center opac flex ${onClick ? 'cursor-pointer' : ''} ${additionalClassName}`}
                    >
                        <div
                            className={`legend-size ${className} ${itemClassName}`}
                            style={{ background: item.color, marginRight: 8, ...style }}
                        ></div>
                        <span style={labelStyle} className={`text-greyFont font-xs ${itemClassName}`}>
                            <Tooltip
                                overlayInnerStyle={{
                                    fontWeight: 500,
                                }}
                                title={showTooltip ? item.fullLabel || item.label : ''}
                                trigger={'hover'}
                            >
                                {item.label}
                            </Tooltip>
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default Legend;
